
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Dialog from "@/components/UI/Dialog.vue";
import { triggerShortcut } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { configStore, documentStore } from "@/store/store-accessor";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import * as t from "io-ts";

@Component({
  components: { Dialog }
})
export default class FirstTimeVisit extends Vue {
  isOpen = configStore.neededData?.isBuilderFirstTimeVisit ?? false;

  get showDialog() {
    return this.isTreeEmpty && this.isOpen;
    // return this.isOpen;
  }

  get isTreeEmpty() {
    return documentStore.document.tree.root.children.length === 0;
  }

  closeForever() {
    this.isOpen = false;

    makeWordPressAjaxRequest({
      action: "breakdance_save_arbitrary",
      dataToPost: {
        key: "onboarding_builder_fist_time_visit",
        data: "true"
      },
      decoder: t.unknown
    });
  }

  openDesignLibrary() {
    triggerShortcut("CMD_B");

    this.closeForever();
  }
}
